package shared.ui.components

import kotlinx.html.*
import features.teams.domain.Team

object TeamCard {
    fun render(parent: DIV, team: Team) {
        console.log("🎴 Rendering team card for:", team.name, "ID:", team.id)
        parent.div("bg-dark-800 rounded-2xl p-6 border border-dark-700 hover:border-brand-green transition duration-300 cursor-pointer shadow-lg hover:shadow-cyan-900/20 group") {
            // Use inline onclick to ensure it's called
            val onclickCode = "console.log('Card clicked!'); window.openTeam('${team.id}')"
            attributes["onclick"] = onclickCode
            console.log("📌 Set onclick attribute to:", onclickCode)
            
            div("flex justify-between items-start mb-4") {
                div("flex items-center gap-3") {
                    div("w-12 h-12 rounded-xl bg-dark-700 border border-dark-600 flex items-center justify-center overflow-hidden shrink-0") {
                        if (team.avatar != null && team.avatar.isNotBlank()) {
                            // Avatar already contains the full data URL with prefix
                            img(src = team.avatar) {
                                classes = setOf("w-full", "h-full", "object-cover")
                            }
                        } else {
                            span("text-2xl") { +"🏢" }
                        }
                    }
                    div {
                        h3("text-lg font-bold text-white group-hover:text-brand-green transition leading-tight") {
                            +team.name
                        }
                        span("text-xs text-slate-500") { +"Created recently" }
                    }
                }
                val badgeClass = when (team.role) {
                    "owner" -> "bg-purple-500/20 text-purple-400"
                    "admin" -> "bg-blue-500/20 text-blue-400"
                    else -> "bg-slate-500/20 text-slate-400"
                }
                span("px-3 py-1 rounded-full text-xs font-bold $badgeClass") {
                    +team.role
                }
            }
            
            div("flex items-center gap-4 text-sm text-slate-400") {
                div("flex items-center gap-1") {
                    span { +"👥" }
                    span { +"${team.memberCount} members" }
                }
                if (team.isArchived) {
                    span("px-2 py-0.5 rounded bg-orange-500/20 text-orange-400 text-xs font-bold") {
                        +"📦 Archived"
                    }
                }
            }
        }
    }
}
